import { INVENTORY_IMAGE_WIDTH } from '@/constants/inventory';
import { getUniqueInventoryImageUrl } from '@/tools/inventory';
import { isMobile } from '@/tools/views';
import { IBasicInventory, InventoryField } from '@lamesarv-sdk/types';

import { InventoryImageSlider } from '../InventoryImageSlider';

interface IItemImageProps {
  item: IBasicInventory;
  customImage?: string;
}

export const InventoryItemImage = ({ item, customImage }: IItemImageProps) => {
  const hasMultipleImages =
    item[InventoryField.imageCloudinaryIds] && item[InventoryField.imageCloudinaryIds].length > 1;

  if (!hasMultipleImages)
    return (
      <img
        src={getUniqueInventoryImageUrl(item, customImage, true)}
        alt={item[InventoryField.title]}
        className="w-full object-cover inventory-item-image"
      />
    );

  return (
    <div className="relative w-full">
      <InventoryImageSlider
        itemId={item[InventoryField.id]}
        width={INVENTORY_IMAGE_WIDTH}
        images={item[InventoryField.imageCloudinaryIds].slice(0, 5)}
        swipe={isMobile()}
        dots
        hideCounter
      />
    </div>
  );
};
